import React from 'react';
import {isMobileOnly as isMobile, isTablet} from 'react-device-detect';
import {Row, Col} from 'reactstrap';

const SubMainHeadlineComponent = (props) => {
  return (
    <Row>
      <Col
        className={`${props.className ? props.className : ''} text-center ${
          isMobile || (isTablet && props.isPortrait) || props.isSmallResolution ? 'p-0' : ''
        }`}>
        <h2 className='main-headline-title d-block text-center' dangerouslySetInnerHTML={{__html: props.title}} />
        <h5 className='main-headline-sub-title d-block text-center' dangerouslySetInnerHTML={{__html: props.subTitle}} />
      </Col>
    </Row>
  );
};

export default SubMainHeadlineComponent;
